export var VaultStatus;
(function (VaultStatus) {
    VaultStatus["VAULT_STATUS_UNSPECIFIED"] = "UNSPECIFIED";
    VaultStatus["VAULT_STATUS_CREATING"] = "CREATING";
    VaultStatus["VAULT_STATUS_CREATION_FAILED"] = "CREATION_FAILED";
    VaultStatus["VAULT_STATUS_ACTIVE"] = "ACTIVE";
    VaultStatus["VAULT_STATUS_DELETING"] = "DELETING";
    VaultStatus["VAULT_STATUS_DELETED"] = "DELETED";
    VaultStatus["VAULT_STATUS_CLEANUP_FAILED"] = "CLEANUP_FAILED";
    VaultStatus["VAULT_STATUS_PENDING_DELETION"] = "PENDING_DELETION";
})(VaultStatus || (VaultStatus = {}));
